// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"59636905","810":"64669549","818":"b39e9e17"}[chunkId] + ".chunk.js";
};